import { useIntl } from 'react-intl';
import { CircularProgress, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { useGetAccountsQuery } from 'services/accountApi';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function AccountNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  // Récupération des comptes depuis l’API
  const { data: accounts = [], isLoading: accountsLoading } = useGetAccountsQuery();

  // Résolution du label du compte sélectionné
  const selectedAccountLabel =
    accounts.find((account) => String(account.id) === String(data?.accountId))?.label ||
    msg({ id: 'field.account.none', defaultMessage: 'Aucun compte sélectionné' });

  return (
    <BaseNode
      id={id}
      icon="lock_icon"
      nodeData={{ ...data, label: msg({ id: 'field.account.label' }) }}
      color="account"
      handleConf={handleConf}
      key={`node-${id}-${data?.accountId}`}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={0} sx={{ p: 1, width: '400px' }}>
        {accountsLoading ? (
          <CircularProgress size={24} sx={{ alignSelf: 'center', my: 2 }} />
        ) : (
          <CompactNodeField
            label={msg({ id: 'field.account.label', defaultMessage: 'Compte' })}
            value={selectedAccountLabel}
          />
        )}

        <CompactNodeField
          label={msg({ id: 'field.outputvar.label', defaultMessage: 'Variable de sortie' })}
          value={data?.outputVar || 'account'}
        />
      </Stack>
    </BaseNode>
  );
}

AccountNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    accountId: PropTypes.string,
    outputVar: PropTypes.string
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
